// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container-homologar-max{\n    overflow-y: auto;\n    max-height: 21rem;\n    margin-bottom: 4px;\n}", "",{"version":3,"sources":["webpack://src/components/production/homologation/modals/assing.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":[".container-homologar-max{\n    overflow-y: auto;\n    max-height: 21rem;\n    margin-bottom: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
